import { render, staticRenderFns } from "./FacebookDisapprovedAdsPage.vue?vue&type=template&id=06841764&scoped=true&"
import script from "./FacebookDisapprovedAdsPage.vue?vue&type=script&lang=js&"
export * from "./FacebookDisapprovedAdsPage.vue?vue&type=script&lang=js&"
import style0 from "./FacebookDisapprovedAdsPage.vue?vue&type=style&index=0&id=06841764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06841764",
  null
  
)

export default component.exports